{
  "es": {
    "levels": {
      "actions": {
        "add_customer": "Añadir cliente",
        "cancel": "Deshacer",
        "changeLevel": "Cambiar nivel",
        "changeTargetGroup": "Cambiar grupo objetivo",
        "delete": "Eliminar",
        "removeCustomer": "Quitar cliente",
        "requestUnits": "Solicitar unidades",
        "save": "Guardar"
      },
      "building": "Edificio",
      "customers": "Clientes",
      "descriptions": {
        "mupCantDelete": "Parece que todavía tienes unidades dentro de este proyecto. Para eliminar el proyecto, te recomendamos eliminar antes las unidades. Así nos aseguramos al 100 % de que el proyecto se puede eliminar.",
        "mupCantDeleteDeactivate": "Una alternativa a eliminar el proyecto es desactivarlo. Así se conservará toda la información para un uso futuro. ¿Quieres desactivar este proyecto?"
      },
      "labels": {
        "activity": "Actividad",
        "aftercare": "Posventa",
        "allLevels": "Todos los niveles",
        "contacts": "Contactos",
        "conversations": "Conversaciones",
        "decisions": "Decisiones",
        "deleteProject": "¿Seguro que quieres eliminar {project_name}?",
        "deleteProjectDisclaimer": "Eliminar este proyecto provocará la pérdida permanente de todos los datos y contenidos. Esta acción es irreversible. Como alternativa, considera desactivar el proyecto para conservar toda la información para un uso futuro. Procede con precaución.",
        "deleteWarning": "¡Ten cuidado! Al eliminar este nivel se eliminarán todos los niveles inferiores, documentos, novedades, preguntas frecuentes y tareas relacionados con este nivel.",
        "documents": "Documentos",
        "download": "Descargar {level_name}",
        "generatingExport": "Generando exportación",
        "hide": "Ocultar",
        "information": "Información",
        "installment": "Finanzas",
        "milestones": "Hitos",
        "multiple_selection": "Selección múltiple",
        "mupCantDelete": "¡Vaya, esta acción no es posible!",
        "needMoreUnits": "¿Necesitas más unidades?",
        "reachedMax": "Has creado la unidad asignada a este proyecto. | Has alcanzado las {count} unidades asignadas a este proyecto.",
        "reachedMaxRundle": "Has alcanzado tu límite de 1 unidad activa. | Has alcanzado tu límite de {count} unidades activas.",
        "requestMoreUnits": "Ponte en contacto con el equipo de Ziggu si quieres solicitar más unidades activas.",
        "settings": "Ajustes del proyecto",
        "sharedWith": "Compartido con ",
        "showForLevel": "Mostrar {object} para el nivel",
        "spaces": "Anejos",
        "surveys": "Encuestas",
        "task_assignments": "Tareas",
        "tickets": "Conversaciones",
        "todos": "Tareas",
        "willBeAssigned": "Disponible para todos en",
        "willBePublished": "Se mostrará a todos en",
        "willBeUploaded": "Se subirá a"
      },
      "lot": "Parcela",
      "phase": "Fase",
      "project": "Proyecto",
      "tooltip": {
        "add_level": "Añadir {level}"
      },
      "unit": "Unidad"
    }
  }
}
